import Axios from "axios";
import { SET_INV_TRANSFER_REPORT, UNSET_INV_TRANSFER_REPORT } from "@/store/mutation-types";
import { getInvTransferReport } from "@/store/api";

const state = { getInvTransferReport: {} };

const getters = {
  getInvTransferReport(state) {
    return state.getInvTransferReport;
  },
};

const mutations = {
  [SET_INV_TRANSFER_REPORT](state, data) {
    state.getInvTransferReport = data;
  },
  [UNSET_INV_TRANSFER_REPORT](state) {
    state.getInvTransferReport = {};
  },
};

const actions = {
  getInvTransferReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvTransferReport, { params: data })
        .then(function (response) {
          commit("SET_INV_TRANSFER_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_TRANSFER_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
